import { ReactNode } from 'react';

import { BrowserRouter } from 'react-router-dom';

import { DE_DIRECT_BASE_PATHNAME, UK_DIRECT_BASE_PATHNAME } from '../constants';

type TProps = {
  children: ReactNode;
};

export const DynamicBrowserRouter = ({ children }: TProps) => {
  const isDirectCustomer =
    window.location.pathname.includes(`/${UK_DIRECT_BASE_PATHNAME}`) ||
    window.location.pathname.includes(`/${DE_DIRECT_BASE_PATHNAME}`);

  return (
    <BrowserRouter basename={`/${isDirectCustomer ? '' : 'partner-signup'}`}>
      {children}
    </BrowserRouter>
  );
};
